import SimpleStringAttribute from './SimpleStringAttribute';

export default class SimpleXStyleLayoutAttribute extends SimpleStringAttribute {
    exportTo(context, styleSet) {
        const style = styleSet.xStyle.layout;
        if (SimpleStringAttribute.hasConstantRef(this.value)) {
            SimpleStringAttribute.exportConstantAsRef(style, this.overrideName, this.value);
        } else {
            style[this.overrideName] = this.value;
        }
    }
}
